import './index.css';

import Clarity from '@microsoft/clarity';
import { PostHogProvider } from '@posthog/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { POSTHOG_KEY, posthogOptions } from 'src/lib/posthog';
import { trackingAllowed } from 'src/utils/cookieConsent';

import App from './App';

if (typeof crypto !== 'undefined' && !crypto.randomUUID) {
  crypto.randomUUID = () =>
    '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) =>
      (+c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))).toString(16)
    ) as `${string}-${string}-${string}-${string}-${string}`;
}

const trackingEnabled = trackingAllowed();

const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID;
if (trackingEnabled && projectId?.trim()) {
  Clarity.init(projectId.trim());
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    {trackingEnabled && POSTHOG_KEY ? (
      <PostHogProvider apiKey={POSTHOG_KEY} options={posthogOptions}>
        <App />
      </PostHogProvider>
    ) : (
      <App />
    )}
  </React.StrictMode>
);
